export default "__VITE_ASSET__BZf25fLq__"